import { PlayerButtonPopup } from '@setplex/arcana'
import { AuthorizePaymentForm } from '../AuthorizePaymentForm'
import { ExternalPaymentOpen } from '../ExternalPaymentOpen'
import { GravyPaymentForm } from '../GravyPaymentForm'
import { NoPaymentForm } from '../NoPaymentForm'

interface PlayerPaymentButtonParams {
  paymentButtonText: string
  openPlayerPaymentPopupEvent: () => void
}
export const PlayerPaymentButton = ({
  paymentButtonText,
  openPlayerPaymentPopupEvent,
}: PlayerPaymentButtonParams) => {
  return (
    <>
      <PlayerButtonPopup
        title={paymentButtonText}
        onSubmit={openPlayerPaymentPopupEvent}
      />
      <GravyPaymentForm />
      <AuthorizePaymentForm />
      <NoPaymentForm />
      <ExternalPaymentOpen />
    </>
  )
}
